var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yht-backStage-hsdt"},[_vm._v(" 红色动态 ")])}
var staticRenderFns = []

export { render, staticRenderFns }